import { useMemo } from 'react'
import { FormSimple } from '../../../shared/form-simple/form'
import { FormSimpleEmail } from '../../../shared/form-simple/form-email'
import { FormSimpleText } from '../../../shared/form-simple/form-text'
import { FormSimpleSubmitSelfRegister } from '../../../shared/form-simple/form-submit'
import { SelfRegisterCard } from './self-register-card'
import { ErrorAlert } from '../../../shared/error/error-alert'

// error: a refused sign-up ({ message, failure }), shown under the button.
export const SelfRegisterForm = ({ apFormSelfRegister, onSubmit, error, onDismissError }) => {
  // Awaited, so the button stays disabled while the sign-up is sent.
  const handleSubmit = data => onSubmit(data)

  // const data = useLocationSearchObject(['email:email', 'first-name:firstName', 'last-name:lastName'])
  // const email = useMemo(() => (data ? data.email : undefined), [data])
  // const firstName = useMemo(() => (data ? data.firstName : undefined), [data])
  // const lastName = useMemo(() => (data ? data.lastName : undefined), [data])

  let colorButtonPrimaryBackground = useMemo(() => apFormSelfRegister.form.colorButtonPrimaryBackground || '', [apFormSelfRegister.form])
  let colorButtonPrimaryText = useMemo(() => apFormSelfRegister.form.colorButtonPrimaryText || '', [apFormSelfRegister.form])

  return (
    <div className="row">
      <div className="mx-auto col-12 col-lg-8">
        <SelfRegisterCard apFormSelfRegister={apFormSelfRegister}>
          <FormSimple state={apFormSelfRegister.form} onSubmit={handleSubmit}>
            <FormSimpleEmail label="email" name="email" required autoComplete="off" />
            <FormSimpleText label="first name" name="firstName" required autoComplete="off" />
            <FormSimpleText label="last name" name="lastName" required autoComplete="off" />
            <FormSimpleSubmitSelfRegister text="Signup" backgroundColor={colorButtonPrimaryBackground} textColor={colorButtonPrimaryText} />
          </FormSimple>
          {error && <ErrorAlert className="mt-2" message={error.message} error={error.failure} onClose={onDismissError} />}
        </SelfRegisterCard>
      </div>
    </div>
  )
}
